<template>
  <!-- <pre class="text-black">{{ props.card?.shadowField?.data }}</pre> -->
  <div
    class="horizontal-card w-full"
    :style="[
      CssStyleHelpers.paddings(cardsGroup.cardsOuterSpacing),
      CssStyleHelpers.margins(cardsGroup.cardsOuterSpacing),
      CssStyleHelpers.background(
        cardsGroup.cardBackgroundColor,
        cardsGroup.isCardBackgroundShown
      ),
    ]"
  >
    <!-- Карточка с контентом -->
    <div
      class="horizontal-card-content flex w-full"
      :style="[CssStyleHelpers.borderRadius(cardsGroup.cardsBorderRadius)]"
    >
      <!-- Медиа секция -->
      <div
        v-if="mainGroup.isShowCardMedia"
        class="horizontal-card-media"
        :style="{
          ...CssStyleHelpers.filterShadow(props.card?.shadowField?.data),
        }"
      >
        <MediaCard
          :media-type="card?.mediaField?.type"
          :image-props="CssImageHelpers.imageProps(card.mediaField?.data)"
          :video-props="CssVideoHelpers.videoProps(card.mediaField?.data)"
          :mask-props="card?.maskField?.data"
          :object-fit="card?.mediaField?.data?.objectFit || 'contain'"
          :border-radius="card?.mediaField?.data?.borderRadius"
          class="h-full w-full"
        />
      </div>

      <!-- Текстовая секция -->
      <div
        v-if="mainGroup.isShowCardText"
        class="horizontal-card-text w-full"
        :style="[
          CssStyleHelpers.background(
            cardsGroup.textBackgroundColor,
            cardsGroup.isTextBackgroundShown
          ),
          CssStyleHelpers.paddings(cardsGroup.cardTextSpacing),
          CssStyleHelpers.borderRadius(cardsGroup.textBorderRadius),
        ]"
      >
        <TextCard :text="card?.textField?.data?.text" class="w-full"/>
      </div>
      
    </div>
  </div>
</template>

<script setup lang="ts">
import MediaCard from "./MediaCard.vue";
import TextCard from "./TextCard.vue";
import {
  CssImageHelpers,
  CssStyleHelpers,
  CssVideoHelpers,
} from "../utils/cssStyleHelpers";

interface HorizontalCardProps {
  // Данные карточки
  card: any;
  // Группа настроек карточек
  cardsGroup?: any;
  mainGroup?: any;
}

const props = defineProps<HorizontalCardProps>();
</script>

<style scoped>
@reference "tailwindcss";
.horizontal-card {
  @apply w-full overflow-hidden;
}

.horizontal-card-content {
  @apply w-full overflow-hidden;
}

.horizontal-card-media {
  @apply overflow-hidden;
  width: auto !important;
  max-width: 140px !important;
  height: auto !important;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.horizontal-card-media :deep(img),
.horizontal-card-media :deep(video),
.horizontal-card-media :deep(.media-container-layer),
.horizontal-card-media :deep(.media-container) {
  object-fit: contain !important;
  width: 100% !important;
  height: auto !important;
  max-height: 180px !important;
}

.horizontal-card-text {
  @apply text-base leading-relaxed;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .horizontal-card-text {
    @apply text-sm;
  }

  /* .horizontal-card-media {
    height: 45% !important;
    margin-bottom: 0.75rem;
  } */
}
</style>

<style>
@reference "tailwindcss";
/* Добавляем базовые стили card-item для совместимости */
.horizontal-card {
  @apply text-base leading-relaxed relative z-10 text-black;
}
</style>
